import { API, slsPublicBaseUrl } from './config'
import { eventsSort, getField } from '../Helpers/Misc'
import { parseTeacherData } from '../Helpers/API'
import { getLocalCurrency } from './Payment'
import { flatten, pipe, propOr, values } from 'ramda'

export const getTeacherPublicProfile = async (livdemyId) =>
  API.get(`${slsPublicBaseUrl}/profile/${livdemyId}`, {
    headers: {
      'local-currency': await getLocalCurrency(),
    },
  })
    .then(async ({ data: { data } }) => {
      let parsed = data
      if (parsed.profileType === 'school') {
        // console.log(
        //   ' ',
        //   parsed.course.find((ele) => ele.type === 'recorded').data || [],
        //   parsed.course.find((ele) => ele.type === 'group').data || [],
        // )
        parsed.recordedCourse = parsed?.course
          ? parsed.course.find((ele) => ele.type === 'recorded')
            ? parsed.course.find((ele) => ele.type === 'recorded').data
            : []
          : []
        parsed.GroupCourse = parsed?.course
          ? parsed.course.find((ele) => ele.type === 'group')
            ? parsed.course.find((ele) => ele.type === 'group').data
            : []
          : []
        if (parsed?.BrodcastCourse && parsed?.BrodcastCourse?.length > 0) {
          parsed.Bcs = [].concat(...parsed.BrodcastCourse)
        }
        if (parsed?.otherBrodcastCourse) {
          parsed.otherBcs = [].concat(...parsed.otherBrodcastCourse)
        }
        parsed.courses = parsed.classes
        parsed.classes = []
      }

      const content =
        parsed.profileType === 'school' ? parsed.school : parsed.profile

      parsed = { ...parsed, ...content }

      if (!parsed.image) {
        parsed.image = parsed.cover
      }

      if (!parsed.classes) {
        parsed.classes = pipe(
          propOr({}, 'broadcastClasses'),
          values,
          flatten,
          eventsSort,
        )(parsed)
        parsed.broadcastClasses = []
      }

      if (!parsed.courses) {
        parsed.courses = parsed.liveCourses
        parsed.liveCourses = []
      }
      return parsed
    })
    .catch(() => false)

export const getAllTeachers = () =>
  API.get('/all-teachers/v2')
    .then((res) => parseTeacherData(getField(res, 'data.data')))
    .catch(() => false)

export const followTeacherRequest = (livdemyId) =>
  API.post(`/follow/livdemy-id/${livdemyId}`)
    .then(() => true)
    .catch(() => false)

export const unfollowTeacher = (livdemyId) =>
  API.post(`/unfollow/livdemy-id/${livdemyId}`)
    .then(() => true)
    .catch(() => false)
